<ac-card>
  <ac-card-content>
    <div class="purchase-dialog" [style.min-height.px]="290">
      @if (!mobilePayTxLoading()) {
        @if (!mobilePayOptions()) {
          <app-purchase-dialog-header
            title="Confirm Purchase"
            (close)="close.emit()"
            (back)="back.emit()"
          />
        }

        <app-purchase-receipt [package]="package()" />

        @if (!mobilePayOptions()) {
          @if (nameMismatchDeclined()) {
            <app-name-mismatch-notice (contactSupport)="close.emit('contact-support')" />
          } @else {
            <app-billing-name-warning [fullName]="fullName()" />
          }
        }

        @if (coinflowToken()) {
          <div class="purchase-dialog__payment-methods-mobile"
               [class.purchase-dialog__payment-methods-mobile--open]="mobilePayOptions()">
            @if (paymentMethod() === 'apple-pay') {
              <lib-coinflow-apple-pay-button [purchaseProps]="applePayPurchaseProps()" />
            }

            @if (paymentMethod() === 'google-pay') {
              <lib-coinflow-google-pay-button [purchaseProps]="googlePayPurchaseProps()" />
            }
          </div>
        } @else {
          <div style="height: 40px" class="ac-flex ac-ctr">
            <ac-loading type="spinner" [size]="20" />
          </div>
        }

        <div class="purchase-dialog__footer ac-label ac-body-sm">
          Payment will show up on your statement from<br />
          GamerGains Labs, Inc.
        </div>
      } @else {
        <div class="ac-ctr ac-flex" [style.margin]="'auto'">
          <app-lottie-animation [size]="160" path="payments_processing" />
        </div>
      }
    </div>
  </ac-card-content>
</ac-card>
